import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../components/layout/ClientLayout";
import BetfairTopNav from "./top-nav-betfair";
import BetfairCasinoBetslipWeb from "./betfair_casino_betslip_web";
import "../../../assets/css/betfair_games.css";
import "../../../assets/css/betfair_games_lo2.css";
import useSocket from "../../../hooks/useSocket";
import axiosInstance from "../../../utils/axiosInstance";
import TPPopUpBetSlip from "../tp-studio/teenpatti_casino_betslip_popup.jsx";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BetfairTurboHold = () => {
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [stakeList, setStakeList] = useState({});
  const [getBetDelayTime, setGetBetDelayTime] = useState([]);

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const dispatch = useDispatch();
  const [isPageLoad, setIsPageLoad] = useState(false);

  const [book1, setBook1] = useState("");
  const [book2, setBook2] = useState("");
  const [book3, setBook3] = useState("");
  const [book4, setBook4] = useState("");
  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  let betfairOdds = null;
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "bfgames",
    type: "turbo_holdem"
  });
  //console.log("Socket data:", data);

  let evt_status = "";
  let roundId = "";
  let timeLeft = "";
  let time_percentage = "";
  let round = "";

  let runner1b1 = "";
  let runner1b2 = "";
  let runner1b3 = "";
  let runner1l1 = "";
  let runner1l2 = "";
  let runner1l3 = "";
  let runner2b1 = "";
  let runner2b2 = "";
  let runner2b3 = "";
  let runner2l1 = "";
  let runner2l2 = "";
  let runner2l3 = "";
  let runner3b1 = "";
  let runner3b2 = "";
  let runner3b3 = "";
  let runner3l1 = "";
  let runner3l2 = "";
  let runner3l3 = "";
  let runner4b1 = "";
  let runner4b2 = "";
  let runner4b3 = "";
  let runner4l1 = "";
  let runner4l2 = "";
  let runner4l3 = "";

  let runner1b1_matched = "";
  let runner1b2_matched = "";
  let runner1b3_matched = "";
  let runner1l1_matched = "";
  let runner1l2_matched = "";
  let runner1l3_matched = "";
  let runner2b1_matched = "";
  let runner2b2_matched = "";
  let runner2b3_matched = "";
  let runner2l1_matched = "";
  let runner2l2_matched = "";
  let runner2l3_matched = "";
  let runner3b1_matched = "";
  let runner3b2_matched = "";
  let runner3b3_matched = "";
  let runner3l1_matched = "";
  let runner3l2_matched = "";
  let runner3l3_matched = "";
  let runner4b1_matched = "";
  let runner4b2_matched = "";
  let runner4b3_matched = "";
  let runner4l1_matched = "";
  let runner4l2_matched = "";
  let runner4l3_matched = "";

  let rnr1_status = "";
  let rnr2_status = "";
  let rnr3_status = "";
  let rnr4_status = "";

  let suspend1 = "";
  let suspend2 = "";
  let suspend3 = "";
  let suspend4 = "";

  let cards_desc = "";
  let cardsDesc = "";

  let rnr1_desc = "";
  let rnr2_desc = "";
  let rnr3_desc = "";
  let rnr4_desc = "";

  let cardsDesc1 = "";
  let cardsDesc2 = "";
  let cardsDesc3 = "";
  let cardsDesc4 = "";
  let max = -219.99078369140625;

  const updateUserData = async (userData) => {
    await dispatch(setUserData(userData));
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  if (data != null && data.data !== null && data.data !== undefined) {
    betfairOdds = data.data;
    updateUserData(data?.user);
    roundId = betfairOdds.roundId;
    evt_status = betfairOdds.evt_status;
    timeLeft = betfairOdds.timeLeft;
    time_percentage = betfairOdds.time_percentage;
    round = betfairOdds.round;

    runner1b1 = betfairOdds.runner1b1;
    runner1b2 = betfairOdds.runner1b2;
    runner1b3 = betfairOdds.runner1b3;
    runner1l1 = betfairOdds.runner1l1;
    runner1l2 = betfairOdds.runner1l2;
    runner1l3 = betfairOdds.runner1l3;
    runner2b1 = betfairOdds.runner2b1;
    runner2b2 = betfairOdds.runner2b2;
    runner2b3 = betfairOdds.runner2b3;
    runner2l1 = betfairOdds.runner2l1;
    runner2l2 = betfairOdds.runner2l2;
    runner2l3 = betfairOdds.runner2l3;
    runner3b1 = betfairOdds.runner3b1;
    runner3b2 = betfairOdds.runner3b2;
    runner3b3 = betfairOdds.runner3b3;
    runner3l1 = betfairOdds.runner3l1;
    runner3l2 = betfairOdds.runner3l2;
    runner3l3 = betfairOdds.runner3l3;
    runner4b1 = betfairOdds.runner4b1;
    runner4b2 = betfairOdds.runner4b2;
    runner4b3 = betfairOdds.runner4b3;
    runner4l1 = betfairOdds.runner4l1;
    runner4l2 = betfairOdds.runner4l2;
    runner4l3 = betfairOdds.runner4l3;

    /*runner1b1_matched = betfairOdds.runner1b1_matched;
    runner1b2_matched = betfairOdds.runner1b2_matched;
    runner1b3_matched = betfairOdds.runner1b3_matched;
    runner1l1_matched = betfairOdds.runner1l1_matched;
    runner1l2_matched = betfairOdds.runner1l2_matched;
    runner1l3_matched = betfairOdds.runner1l3_matched;
    runner2b1_matched = betfairOdds.runner2b1_matched;
    runner2b2_matched = betfairOdds.runner2b2_matched;
    runner2b3_matched = betfairOdds.runner2b3_matched;
    runner2l1_matched = betfairOdds.runner2l1_matched;
    runner2l2_matched = betfairOdds.runner2l2_matched;
    runner2l3_matched = betfairOdds.runner2l3_matched;
    runner3b1_matched = betfairOdds.runner3b1_matched;
    runner3b2_matched = betfairOdds.runner3b2_matched;
    runner3b3_matched = betfairOdds.runner3b3_matched;
    runner3l1_matched = betfairOdds.runner3l1_matched;
    runner3l2_matched = betfairOdds.runner3l2_matched;
    runner3l3_matched = betfairOdds.runner3l3_matched;
    runner4b1_matched = betfairOdds.runner4b1_matched;
    runner4b2_matched = betfairOdds.runner4b2_matched;
    runner4b3_matched = betfairOdds.runner4b3_matched;
    runner4l1_matched = betfairOdds.runner4l1_matched;
    runner4l2_matched = betfairOdds.runner4l2_matched;
    runner4l3_matched = betfairOdds.runner4l3_matched;*/

    runner1b1_matched = formatTruncate(betfairOdds?.runner1b1_matched);
    runner1b2_matched = formatTruncate(betfairOdds?.runner1b2_matched);
    runner1b3_matched = formatTruncate(betfairOdds?.runner1b3_matched);
    runner1l1_matched = formatTruncate(betfairOdds?.runner1l1_matched);
    runner1l2_matched = formatTruncate(betfairOdds?.runner1l2_matched);
    runner1l3_matched = formatTruncate(betfairOdds?.runner1l3_matched);
    runner2b1_matched = formatTruncate(betfairOdds?.runner2b1_matched);
    runner2b2_matched = formatTruncate(betfairOdds?.runner2b2_matched);
    runner2b3_matched = formatTruncate(betfairOdds?.runner2b3_matched);
    runner2l1_matched = formatTruncate(betfairOdds?.runner2l1_matched);
    runner2l2_matched = formatTruncate(betfairOdds?.runner2l2_matched);
    runner2l3_matched = formatTruncate(betfairOdds?.runner2l3_matched);
    runner3b1_matched = formatTruncate(betfairOdds?.runner3b1_matched);
    runner3b2_matched = formatTruncate(betfairOdds?.runner3b2_matched);
    runner3b3_matched = formatTruncate(betfairOdds?.runner3b3_matched);
    runner3l1_matched = formatTruncate(betfairOdds?.runner3l1_matched);
    runner3l2_matched = formatTruncate(betfairOdds?.runner3l2_matched);
    runner3l3_matched = formatTruncate(betfairOdds?.runner3l3_matched);
    runner4b1_matched = formatTruncate(betfairOdds?.runner4b1_matched);
    runner4b2_matched = formatTruncate(betfairOdds?.runner4b2_matched);
    runner4b3_matched = formatTruncate(betfairOdds?.runner4b3_matched);
    runner4l1_matched = formatTruncate(betfairOdds?.runner4l1_matched);
    runner4l2_matched = formatTruncate(betfairOdds?.runner4l2_matched);
    runner4l3_matched = formatTruncate(betfairOdds?.runner4l3_matched);

    rnr1_status = betfairOdds.rnr1_status;
    rnr2_status = betfairOdds.rnr2_status;
    rnr3_status = betfairOdds.rnr3_status;
    rnr4_status = betfairOdds.rnr4_status;

    suspend1 = betfairOdds.suspend1;
    suspend2 = betfairOdds.suspend2;
    suspend3 = betfairOdds.suspend3;
    suspend4 = betfairOdds.suspend4;

    if (evt_status == "SUSPENDED_GAME_ROUND_OVER") {
      if (rnr1_status != "IN_PLAY") {
        rnr1_status = rnr1_status;
      } else {
        rnr1_status = "ROUND OVER !";
      }

      if (rnr2_status != "IN_PLAY") {
        rnr2_status = rnr2_status;
      } else {
        rnr2_status = "ROUND OVER !";
      }

      if (rnr3_status != "IN_PLAY") {
        rnr3_status = rnr3_status;
      } else {
        rnr3_status = "ROUND OVER !";
      }

      if (rnr4_status != "IN_PLAY") {
        rnr4_status = rnr4_status;
      } else {
        rnr4_status = "ROUND OVER !";
      }
    }

    ///
    cards_desc = betfairOdds.cards_desc;
    cardsDesc = cards_desc.split(",");

    rnr1_desc = betfairOdds.rnr1_desc;
    cardsDesc1 = rnr1_desc.split(",");
    rnr2_desc = betfairOdds.rnr2_desc;
    cardsDesc2 = rnr2_desc.split(",");
    rnr3_desc = betfairOdds.rnr3_desc;
    cardsDesc3 = rnr3_desc.split(",");
    rnr4_desc = betfairOdds.rnr4_desc;
    cardsDesc4 = rnr4_desc.split(",");
  }
  const getCardImage = (cardValue) => {
    if (cardValue === "NOT AVAILABLE") {
      return `/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg`;
    }

    if (["28", "33", "39", "40"].includes(cardValue)) {
      return `/assets/images/bpstudio/cards/card_simple_${cardValue}.png`;
    }

    return `/assets/images/bpstudio/cards/card_simple_${cardValue}.svg`;
  };

  useEffect(() => {
    if (data !== null && data !== undefined) {
      setIsPageLoad(true);
    }
  }, [data]);


  /// place bet ///

  const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
    if (price <= 0) {
      return;
    }
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "betfair_turbo_hold"
    };
    placeBetObject.catmid = roundId;
    placeBetObject.round = round;
    //console.log(placeBetObject);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 9;

    setPlaceBetObject(placeBetObject);
    console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };
  /// place bet ///

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const getDelayTimes = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/event-limits");
      setGetBetDelayTime(data);
    } catch (error) {
      console.error("Failed to load getDelayTimes data:", error);
    }
  };

  const delayTime = (game_type) => {
    let defaultTime = 8;
    if (getBetDelayTime) {
      for (let i = 0; i < getBetDelayTime.response?.length; i++) {
        let obj = getBetDelayTime.response[i];
        if (obj.game_type == game_type) {
          defaultTime = obj.value;
          break;
        }
      }
    }

    return defaultTime;
  };

  const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
  const isProcessing = useRef(false);
  const [loading, setLoading] = useState(false);

  const placeBet = async (amount, profit) => {
    if (isProcessing.current) return;

    isProcessing.current = true;
    setLoading(true);

    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    let delay = delayTime(7);
    console.log("delay->", delay);
    try {
      await sleep(delay * 1000);
      const response = await axiosInstance.post(
        "/betfair-turbo-hold",
        placeBetObject
      );
      console.log(response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
        //toast.success(response.data.message);
        setShowBetSlipPopup(false);
        //getBook(placeBetObject.catmid);
        fetchUserData(); //balance update on top
        getBook();
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
          //toast.error(errorMessage);
        }
      }
    } finally {
      isProcessing.current = false;
      setLoading(false);
    }
  };

  const fetchUserData = async () => {
    //console.log("Fetching events...");
    try {
      const response = await axiosInstance.get("/user");
      //console.log("user-response->",response);
      if (response.data !== "") {
        await dispatch(setUserData(response.data));
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);

      setStakeList({
        stake1: data.response.stake1,
        stake2: data.response.stake2,
        stake3: data.response.stake3,
        stake4: data.response.stake4,
        stake5: data.response.stake5,
        stake6: data.response.stake6,
        stake7: data.response.stake7,
        stake8: data.response.stake8
      });
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
    getDelayTimes();
  }, []);

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId;
    bookObject.game_type = "betfair-turbo-hold";

    const response = await axiosInstance.post("/betfair-book", bookObject);
    console.log("response->", response.data);
    ///
    let userbook = response.data.userbook;
    let bet_list = response.data.bets_list;
    if (userbook.length > 0) {
      let book1Val = userbook[0].rnr1s;
      let book2Val = userbook[0].rnr2s;
      let book3Val = userbook[0].rnr3s;
      let book4Val = userbook[0].rnr4s;

      setBook1(book1Val);
      setBook2(book2Val);
      setBook3(book3Val);
      setBook4(book4Val);
    } else {
      setBook1("");
      setBook2("");
      setBook3("");
      setBook4("");
    }

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }
    ///
    return response;
  };

  useEffect(
    (roundId) => {
      getBook();
    },
    [roundId]
  ); // Empty dependency array

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "betfair-turbo-hold";

    const response = await axiosInstance.post("/betfair-results", resultObj);

    setResultData(response.data.results_list);
    console.log("response->", resultData);
    setShowResult(true);
  };

  const hideResultDetail = async () => {
    setShowResult(false);
  };

  ///
  const tableStyle = { width: "100%", borderCollapse: "collapse" };
  const rowFlexStyle = {
    display: "flex",
    justifyContent: "center",
    background: "transparent"
  };
  const tdResultsStyle = {
    padding: "0px 0px 0px 0px",
    flex: "1 1 auto",
    boxSizing: "border-box",
    height: "110px"
  };
  const playerCardsStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowWrap: "break-word"
  };
  const playerNameStyle = {
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const cardImagesStyle = {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%"
  };
  const cardImgStyle = {
    width: 40,
    height: 60,
    objectFit: "cover",
    borderRadius: 5
  };
  const playerStatusStyle = {
    color: "#000",
    marginTop: 5,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const communityTdStyle = {
    boxSizing: "border-box",
    width: "100%"
  };
  ///

  const closeButton = () => {
    setShowModal(false);
  };

  const formatResultDate = (dateString) => {
    const date = new Date(dateString);

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${month}/${day}, ${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  return (
    <ClientLayout showLoader={false}>
      <style>
        {`
          .ExMainCardbundle .runner-position {
            bottom: 0px;
         }
          .ExMainCardbundle .runner-name {
              padding-top: 1px;
          }
          .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            max-width: calc(33.33% - 20px);
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
          }
        .bgwinner {
            border-radius: 10px;
            background-color: #cf8d2e !important;
        }
        .bgLoser {
            border-radius: 10px;
            background-color: #cf3f3f !important;
        }
        .TdResultsWin {
            background: #008000 !important;
        }
        .player-card.stood, .andarbahar-player-card {
          margin-left:auto;
          margin-right:auto;
          min-height:auto;
        }
        .modal-content-style {
          max-width: 1000px !important;
          width: 100% !important;
          max-height: 95vh !important;
        }
         @media (max-width:768px)
          {
            .community-cards td{
              display:block;
              width:50% !important;
              box-sizing:border-box;
            }
            .community-cards{
              background:red !important;
              display:flex !important;
              flex-wrap:wrap;
              justify-content:center;
            }
            .community-cards .TdResults{
              flex:0 0 50%;
              width: 50% !important;
              max-width:50% !important;  
              box-sizing: border-box;
            }

            .community-row {
                display: grid !important;
                grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
                gap: 3px !important;
                width: 100% !important;
                box-sizing: border-box !important;
              }

              /* Hand 1, 2, 3 */
              .community-row .TdResults {
                width: auto !important;
                max-width: none !important;
                min-width: 0 !important;
                flex: none !important;
                box-sizing: border-box !important;
              }

              /* Hand 4 */
              .community-row .TdResults:nth-child(4) {
                grid-column: 1 / -1 !important;
                width: 100% !important;
              }

              .community-row .player-status {
                width: 100% !important;
                box-sizing: border-box !important;
                margin-left: 0 !important;
                margin-right: 0 !important;
              }

              .community-row .TdResults:nth-child(1) .player-status,
              .community-row .TdResults:nth-child(2) .player-status,
              .community-row .TdResults:nth-child(3) .player-status {
                width: 127px !important;
                box-sizing: border-box !important;
              }

              /* Hand 4 status bar */
              .community-row .TdResults:nth-child(4) .player-status {
                width: 389px !important;
                box-sizing: border-box !important;
              }

            .TdResults{
              flex:0 0 50%;
              max-width:50%;
              min-width:0;
              box-sizing:border-box;
              padding:0px 8px 0 8px !important;
            }
            .players-table table{
              border-collapse: separate !important;
              border-spacing: 2px !important;
            }
            .players-table .community-cell {
              vertical-align: top;
              flex: 0 0 100% !important; 
              box-sizing: border-box;
              background: linear-gradient(#535353, #0f0f0f);
              border-radius: 10px;
              margin: 1px;
              max-width:100%;
            }
            .players-table table{
              width:100%;
              table-layout:fixed;
            }
            .community-row td{
              width:100%;
            }
            .community-row .card-images img{
              margin:1px;
            }
            .card-images{
              display:flex !important;
              flex-direction:row !important;
              flex-wrap:nowrap;
              justify-content:center;
            }
            .card-images img{
              display:inline-block;
            }
            .player-status{
              width: 160px !important;
            }
            .col-lg-8 {
              padding-left: 0px;
              padding-right: 0px;
            }
            .card-header {
              padding: 0.3rem 0.25rem;
              border-bottom: 1px solid rgba(0, 0, 0, 0.125);
            }
            .hands-row{
              display:flex;
              flex-wrap:wrap;
            }

            .hands-row .TdResults{
              width:50%;
              box-sizing:border-box;
            }
            .community-row{
              display:flex !important;
              flex-wrap:wrap !important;
            }

            .community-row .TdResults{
              width:50% !important;
              max-width:50% !important;
              flex:0 0 50% !important;
            }
            .players-table tbody tr:first-child{
              display:block !important;
            }

            .players-table tbody tr:first-child .TdResults{
              width:100% !important;
              max-width:100% !important;
            }
            .players-table tbody tr:first-child{
              display:block !important;
              width:100%;
            }

            .players-table tbody tr:first-child .TdResults{
              display:block;
              width:100% !important;
              max-width:none !important;
            }
            .players-table tbody tr:nth-child(2){
              display:grid !important;
              grid-template-columns: 1fr 1fr;
              gap:6px;
            }

            .players-table tbody tr:nth-child(2) .TdResults{
              width:100% !important;
              max-width:100% !important;
            }
          }
          .no-border {
            border-bottom: none !important;
          }
        `}
      </style>
      <div
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          background: "#ffffff"
        }}
      >
        <div className="ExMainCardbundle" style={{ marginBottom: "2px" }}>
          <div
            className="card-header"
            style={{
              background: "#ffffff",
              paddingBottom: "3px",
              paddingTop: "3px"
            }}
          >
            <BetfairTopNav></BetfairTopNav>
          </div>

          {!isPageLoad && (
            <div
              style={{
                zIndex: "1000",
                background: "#fff",
                width: "100%",
                height: "20%",
                opacity: 1,
                textAlign: "center"
              }}
            >
              <div>
                <img src="../assets/images/loadinggif.gif" alt="Loader" />
              </div>
            </div>
          )}

          <div
            className="card-body mainexcard"
            id="afterAnimation"
            style={{ display: isPageLoad ? "block" : "none" }}
          >
            <div id="ExgamesDiv" className="row">
              <div className="col-lg-8 Exgamesbg">
                <div>
                  <div
                    className="container text-center"
                    style={{
                      background: "#292929",
                      width: isMobile ? "95%" : "100%",
                      padding: "3px"
                    }}
                  >
                    <center className="row">
                      <div className="col-md-4 ExRounds">
                        <div className="round-counter-simple">
                          <div className="round-counter-text">
                            <span className="i18n">Round</span>
                          </div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 1 ? "active" : ""
                            }`}
                            id="roundCounter1"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 2 ? "active" : ""
                            }`}
                            id="roundCounter2"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 3 ? "active" : ""
                            }`}
                            id="roundCounter3"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 4 ? "active" : ""
                            }`}
                            id="roundCounter4"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 5 ? "active" : ""
                            }`}
                            id="roundCounter5"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 6 ? "active" : ""
                            }`}
                            id="roundCounter6"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 7 ? "active" : ""
                            }`}
                            id="roundCounter7"
                          ></div>
                        </div>
                      </div>
                      <div className="col-4 col-md-4">
                        <div id="demoTimer" className="col">
                          <div className="base-timer casino-timer">
                            <svg
                              className="progressBar"
                              x="0px"
                              y="0px"
                              viewBox="0 0 80 80"
                            >
                              <path
                                className="track"
                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                              />
                              <path
                                className="fill fill_green"
                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                style={{
                                  strokeDashoffset: ((30 - timeLeft) / 30) * max
                                }}
                              />
                              <text
                                className="value"
                                x="50%"
                                y="55%"
                                style={{
                                  fontSize: "30px",
                                  fontWeight: "bold"
                                }}
                              >
                                {timeLeft}
                              </text>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="col-8  col-md-4 inline-block Gameidcol">
                        Game ID:<span id="round-id">{roundId}</span>
                        <div
                          role="group"
                          aria-label="Second group"
                          className="btn-group btn-group-sm mr-2"
                        >
                          <button
                            type="button"
                            id="Alltab"
                            className={`tablink 
                                                btn 
                                                btn-primary 
                                                ${
                                                  showResult ? "" : "bbactive"
                                                }`}
                            onClick={() => hideResultDetail()}
                          >
                            Game
                          </button>
                          <button
                            type="button"
                            id="RESULTStab"
                            className={`tablink 
                                            btn 
                                            btn-primary 
                                            ${showResult ? "bbactive" : ""}`}
                            onClick={() => showResultDetail()}
                          >
                            Results
                          </button>
                          <button
                            type="button"
                            className="tablink btn btn-primary "
                            data-toggle="modal"
                            data-target="#rulesPopup"
                            style={{ display: "inline-block" }}
                            onClick={() => setShowModal(true)}
                          >
                            Rules
                          </button>
                          {showModal && (
                            <div
                              class="modal fade  show"
                              id="rulesPopup"
                              tabindex="-1"
                              role="dialog"
                              data-keyboard="false"
                              data-backdrop="static"
                              style={{ display: "block" }}
                            >
                              <div
                                class="modal-dialog modal-lg"
                                role="document"
                              >
                                <div
                                  class="modal-content modal-content-style"
                                  style={{
                                    backgroundColor: "#3C444B",
                                    color: "#AAAFB5",
                                    borderRadius: "6px"
                                  }}
                                >
                                  <div
                                    class="modal-header"
                                    style={{
                                      borderBottom: "0px",
                                      padding: "5px",
                                      background: "#e0e0e0"
                                    }}
                                  >
                                    <div
                                      class="modal-title"
                                      id="exampleModalLabel"
                                      style={{
                                        fontSize: "20px",
                                        color: "rgba(0,0,0,.87)",
                                        margin: "5px 0px 0px 10px"
                                      }}
                                    >
                                      <b>Market Rules</b>
                                    </div>
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      style={{
                                        color: "white",
                                        margin: "-0.5rem -0.7rem -1rem auto"
                                      }}
                                    >
                                      <span
                                        aria-hidden="true"
                                        style={{
                                          color: "#000",
                                          opacity: "0.8"
                                        }}
                                        onClick={closeButton}
                                      >
                                        ×
                                      </span>
                                    </button>
                                  </div>
                                  <div
                                    class="modal-body"
                                    style={{
                                      marginTop: "0px",
                                      background: "#fff"
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: "#fff",
                                        padding: "10px",
                                        borderRadius: "10px"
                                      }}
                                    >
                                      <div class="row">
                                        <div
                                          class="col-lg-12"
                                          style={{ color: "rgba(0,0,0,.87)" }}
                                        >
                                          <div
                                            id="market-rules-text"
                                            class="modal-body"
                                          >
                                            <div style={{ textAlign: "left" }}>
                                              <p class="paragraph">
                                                The rank system that determines
                                                the winning hand is as follows,
                                                with the highest first: This
                                                game is based on the poker game
                                                commonly known as{" "}
                                                <b> 'Texas Hold'em'.</b>
                                              </p>
                                              <p class="paragraph">
                                                Each game begins with 13 cards
                                                being dealt face down from a
                                                shuffled pack. 8 of the cards
                                                are paired to form 4 separate
                                                hands (
                                                <b>
                                                  {" "}
                                                  these cards in the pairs are
                                                  known as{" "}
                                                  <span class="emphasize">
                                                    hole cards
                                                  </span>{" "}
                                                </b>
                                                ). The remaining 5 cards form a
                                                pool of{" "}
                                                <span class="emphasize">
                                                  community cards.
                                                </span>
                                              </p>
                                              <p class="paragraph">
                                                {" "}
                                                A first round of betting takes
                                                place whilst all cards are face
                                                down (<b>the deal</b>). Players
                                                bet on which individual hand
                                                they think will win the game.
                                                Bets can be placed to{" "}
                                                <span class="emphasize">
                                                  Back
                                                </span>{" "}
                                                or{" "}
                                                <span class="emphasize">
                                                  Lay
                                                </span>{" "}
                                                each hand.{" "}
                                              </p>
                                              <p class="paragraph">
                                                {" "}
                                                At the end of the first round of
                                                betting, unmatched bets are
                                                cancelled and the pairs of cards
                                                forming the individual hands are
                                                simultaneously turned face up.
                                                There is then a second round of
                                                betting. Again, bets can Back or
                                                Lay each individual hand within
                                                the game (Pre-flop).{" "}
                                              </p>
                                              <p class="paragraph">
                                                {" "}
                                                Each round of betting lasts for
                                                a set period of time. This
                                                period is indicated by the
                                                counter in the center of the
                                                screen. (
                                                <b>
                                                  Please note the counter is
                                                  indicative only
                                                </b>
                                                ).{" "}
                                              </p>
                                              <p class="paragraph">
                                                {" "}
                                                At the end of the second round
                                                of betting unmatched bets are
                                                cancelled and the first three of
                                                the community cards are turned
                                                face up (<b>'the flop'</b>).
                                                Another round of betting begins.{" "}
                                              </p>
                                              <p class="paragraph">
                                                {" "}
                                                The end of the third round of
                                                betting unmatched bets are
                                                cancelled before the fourth card
                                                from the community cards is
                                                turned face up. (
                                                <b>
                                                  This card is sometimes known
                                                  as the 'turn'.
                                                </b>
                                                ) Another round of betting then
                                                commences.{" "}
                                              </p>
                                              <p class="paragraph">
                                                {" "}
                                                The fourth and final round of
                                                betting finishes with unmatched
                                                bets cancelled before the fifth
                                                and final of the community cards
                                                is turned face up (this is
                                                sometimes known as the{" "}
                                                <b>'river'</b>).{" "}
                                              </p>
                                              <p class="paragraph">
                                                {" "}
                                                The result of the game is
                                                determined by which hand is best
                                                within the predetermined rank
                                                system. Should two hands be of
                                                equal standing then Dead Heat
                                                rules will apply.{" "}
                                              </p>

                                              <h3 class="section-highlight">
                                                <span class="i18n">
                                                  Each hand may consist of the
                                                  following:
                                                </span>
                                              </h3>
                                              <ul class="helpList">
                                                <li>
                                                  Both hole cards and three
                                                  community cards
                                                </li>
                                                <li>
                                                  One hole card and four
                                                  community cards
                                                </li>
                                                <li>
                                                  All five community cards
                                                </li>
                                              </ul>
                                              <p class="paragraph"></p>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    Royal Flush:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  Ace, King, Queen, Jack, Ten of
                                                  the same suit.
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    Straight Flush:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  Straight with all five cards
                                                  in the same suit.
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    Four of a Kind:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  Four cards of the same number
                                                  or face value ('quads').
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    Full House:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  Three cards of one number or
                                                  face value and two cards of
                                                  another number or face value.
                                                  If more than one player has a
                                                  full house, the full house
                                                  with the highest ranking three
                                                  of a kind ('trips') wins.{" "}
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    Flush:{" "}
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  Five cards of the same suit.
                                                  If there is more than one
                                                  flush, the hand with the
                                                  highest card(s) wins.
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    Straight:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  Five cards in sequence. Cards
                                                  can be in any suit. An Ace can
                                                  be used in the highest
                                                  straight (10, J, Q, K, A) and
                                                  the lowest straight (A, 2, 3,
                                                  4, 5). If there is more than
                                                  one straight, the hand with
                                                  the highest card in the
                                                  straight wins.{" "}
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    Three of a Kind:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  Three cards of the same number
                                                  or face value ('trips').
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    Two Pair:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  If two players have two pair,
                                                  the hand with the highest pair
                                                  wins. If they have the same
                                                  high pair, whoever has the
                                                  second highest pair wins. If
                                                  they have the same two pair,
                                                  whoever has the highest fifth
                                                  card ('kicker') wins.{" "}
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    One Pair:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  {" "}
                                                  Two cards of the same number
                                                  or face value. If two players
                                                  have the same pair, the
                                                  highest outside card(s) wins.{" "}
                                                </div>
                                              </div>
                                              <div class="clearfix helpItem">
                                                <h4 class="section-highlight">
                                                  <span class="i18n">
                                                    High Card:
                                                  </span>
                                                </h4>
                                                <div class="right helpDescription">
                                                  The hand with the highest
                                                  card(s) wins.
                                                </div>
                                              </div>
                                              <p class="paragraph">
                                                {" "}
                                                Should two or more hands have
                                                cards or combinations of cards
                                                with equal standing and value
                                                then the value of the remaining
                                                cards in that hand is used to
                                                determine the winner (sometimes
                                                know as the kicker). Should one
                                                or more hands still be of equal
                                                values then dead heat rules will
                                                apply to the winning hands
                                                (sometimes known as 'splitting
                                                the pot').{" "}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <section class="footer-section">
                                <div class="container">
                                  <div class="row"></div>
                                  <div class="row">
                                    <div class="col-md-6">
                                      <div class="footer-text">
                                        <p>
                                          {" "}
                                          Betproexch is operated by RAEEN
                                          Exchange N.V registered under
                                          No.155342 at,Schottegatweg Oost
                                          72A.This website is licensed and
                                          regulated by Curacao eGaming (Curacao
                                          license No 1668 JAZ issued by Curacao
                                          eGaming)
                                        </p>
                                      </div>
                                    </div>
                                    <div class="col-md-5">
                                      <div class="footer-logo">
                                        <div class="footer-logo1">
                                          <img
                                            class="img-fluid"
                                            src="/assets/images/validate.png"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                            </div>
                          )}
                        </div>
                      </div>
                    </center>
                  </div>
                </div>
                <div
                  id="AlltabData"
                  className="tabcontent"
                  style={{ display: showResult ? "none" : "contents" }}
                >
                  <div className="left-content" style={{ padding: "5px" }}>
                    <div className="cards-layout blackjack">
                      <div style={{ color: "white" }}>
                        <span
                          className={
                            round == 1 ? "fsizeL roundText" : "fsizeS roundText"
                          }
                          id="round1"
                        >
                          Deal{" "}
                        </span>{" "}
                        |
                        <span style={{ fontSize: "large" }}>
                          <span
                            className={
                              round == 2
                                ? "fsizeL roundText"
                                : "fsizeS roundText"
                            }
                            id="round2"
                          >
                            Preflop{" "}
                          </span>
                        </span>{" "}
                        |
                        <span style={{ fontSize: "large" }}>
                          <span
                            className={
                              round == 3
                                ? "fsizeL roundText"
                                : "fsizeS roundText"
                            }
                            id="round3"
                          >
                            Flop{" "}
                          </span>
                        </span>{" "}
                        |
                        <span style={{ fontSize: "large" }}>
                          <span
                            className={
                              round == 4
                                ? "fsizeL roundText"
                                : "fsizeS roundText"
                            }
                            id="round4"
                          >
                            Turn{" "}
                          </span>
                        </span>{" "}
                        |
                        <span style={{ fontSize: "large" }}>
                          <span
                            className={
                              round == 5
                                ? "fsizeL roundText"
                                : "fsizeS roundText"
                            }
                            id="round5"
                          >
                            River{" "}
                          </span>
                        </span>
                      </div>

                      <div>
                        <div className="dealer">
                          <div className="player-item">
                            <span className="name">Community Cards</span>
                            <div
                              className="player-card"
                              style={{ padding: "0px" }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandViewDealer"
                              >
                                <div id="cards_desc" className="BFBCardFanView">
                                  {cardsDesc &&
                                    cardsDesc.length > 0 &&
                                    cardsDesc.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in5`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="player">
                          <div className="player-item">
                            <span className="name">Hand 1</span>
                            <div
                              className="player-card  stood"
                              style={{
                                padding: "unset",
                                width: "auto",
                                height: "auto"
                              }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandView"
                              >
                                <div id="rnr1_desc" className="BFBCardFanView">
                                  {cardsDesc1 &&
                                    cardsDesc1.length > 0 &&
                                    cardsDesc1.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in2`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="player">
                          <div className="player-item">
                            <span className="name">Hand 2</span>
                            <div
                              className="player-card  stood"
                              style={{
                                padding: "unset",
                                width: "auto",
                                height: "auto"
                              }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandView"
                              >
                                <div id="rnr2_desc" className="BFBCardFanView">
                                  {cardsDesc2 &&
                                    cardsDesc2.length > 0 &&
                                    cardsDesc2.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in2`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="player">
                          <div className="player-item">
                            <span className="name">Hand 3</span>
                            <div
                              className="player-card  stood"
                              style={{
                                padding: "unset",
                                width: "auto",
                                height: "auto"
                              }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandView"
                              >
                                <div id="rnr3_desc" className="BFBCardFanView">
                                  {cardsDesc3 &&
                                    cardsDesc3.length > 0 &&
                                    cardsDesc3.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in2`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="player">
                          <div className="player-item">
                            <span className="name">Hand 4</span>
                            <div
                              className="player-card  stood"
                              style={{
                                padding: "unset",
                                width: "auto",
                                height: "auto"
                              }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandView"
                              >
                                <div id="rnr4_desc" className="BFBCardFanView">
                                  {cardsDesc4 &&
                                    cardsDesc4.length > 0 &&
                                    cardsDesc4.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in2`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <center>
                      <div
                        className="progress"
                        style={{
                          height: "3px",
                          maxWidth: "50%",
                          marginBottom: "8px"
                        }}
                      >
                        <div
                          id="Exgamesprogress"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          className="progress-bar bg-danger"
                          style={{ width: `${time_percentage}%` }}
                          sid="roundProgressWidth"
                        ></div>
                      </div>
                    </center>
                    <div className="section-blur">
                      <div className="market-titlebar">
                        <p className="market-name"></p>
                        <div className="market-overarround">
                          <span></span>
                          <strong>Back</strong>
                        </div>
                        <div className="market-overarround market-overarround-lay">
                          <strong>Lay</strong>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b1status">
                          <h3
                            className={`runner-name ${
                              rnr1_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hand 1
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus1">
                                    {book1 !== "" ? (
                                      Number(book1) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book1)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book1)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr1_status span1details"
                            id="runner1b3span"
                            data-teamname="Hand 1"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 1", "3", runner1b3)
                            }
                          >
                            <span className="price-odd" id="runner1b3">
                              {runner1b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b3_matched"
                            >
                              {runner1b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr1_status span1details"
                            id="runner1b2span"
                            data-teamname="Hand 1"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 1", "2", runner1b2)
                            }
                          >
                            <span className="price-odd" id="runner1b2">
                              {runner1b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b2_matched"
                            >
                              {runner1b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr1_status span1details"
                            id="runner1b1span"
                            data-teamname="Hand 1"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 1", "1", runner1b1)
                            }
                          >
                            <span className="price-odd" id="runner1b1">
                              {runner1b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b1_matched"
                            >
                              {runner1b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr1_status span1details"
                            id="runner1l1span"
                            data-teamname="Hand 1"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 1", "1", runner1l1)
                            }
                          >
                            <span className="price-odd" id="runner1l1">
                              {runner1l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l1_matched"
                            >
                              {runner1l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr1_status span1details"
                            id="runner1l2span"
                            data-teamname="Hand 1"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 1", "2", runner1l2)
                            }
                          >
                            <span className="price-odd" id="runner1l2">
                              {runner1l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l2_matched"
                            >
                              {runner1l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr1_status span1details"
                            id="runner1l3span"
                            data-teamname="Hand 1"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 1", "3", runner1l3)
                            }
                          >
                            <span className="price-odd" id="runner1l3">
                              {runner1l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l3_matched"
                            >
                              {runner1l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr1_status"
                            style={{
                              display:
                                suspend1 != 0 ||
                                rnr1_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr1_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b2status">
                          <h3
                            className={`runner-name ${
                              rnr2_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hand 2
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus2">
                                    {book2 !== "" ? (
                                      Number(book2) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book2)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book2)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr2_status span1details"
                            id="runner2b3span"
                            data-teamname="Hand 2"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 2", "3", runner2b3)
                            }
                          >
                            <span className="price-odd" id="runner2b3">
                              {runner2b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b3_matched"
                            >
                              {runner2b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr2_status span1details"
                            id="runner2b2span"
                            data-teamname="Hand 2"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 2", "2", runner2b2)
                            }
                          >
                            <span className="price-odd" id="runner2b2">
                              {runner2b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b2_matched"
                            >
                              {runner2b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr2_status span1details"
                            id="runner2b1span"
                            data-teamname="Hand 2"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 2", "1", runner2b1)
                            }
                          >
                            <span className="price-odd" id="runner2b1">
                              {runner2b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b1_matched"
                            >
                              {runner2b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr2_status span1details"
                            id="runner2l1span"
                            data-teamname="Hand 2"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 2", "1", runner2l1)
                            }
                          >
                            <span className="price-odd" id="runner2l1">
                              {runner2l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l1_matched"
                            >
                              {runner2l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr2_status span1details"
                            id="runner2l2span"
                            data-teamname="Hand 2"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 2", "2", runner2l2)
                            }
                          >
                            <span className="price-odd" id="runner2l2">
                              {runner2l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l2_matched"
                            >
                              {runner2l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr2_status span1details"
                            id="runner2l3span"
                            data-teamname="Hand 2"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 2", "3", runner2l3)
                            }
                          >
                            <span className="price-odd" id="runner2l3">
                              {runner2l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l3_matched"
                            >
                              {runner2l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr2_status"
                            style={{
                              display:
                                suspend2 != 0 ||
                                rnr2_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr2_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b3status">
                          <h3
                            className={`runner-name ${
                              rnr3_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hand 3
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus3">
                                    {book3 !== "" ? (
                                      Number(book3) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book3)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book3)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr3_status span1details"
                            id="runner3b3span"
                            data-teamname="Hand 3"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 3", "3", runner3b3)
                            }
                          >
                            <span className="price-odd" id="runner3b3">
                              {runner3b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b3_matched"
                            >
                              {runner3b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr3_status span1details"
                            id="runner3b2span"
                            data-teamname="Hand 3"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 3", "2", runner3b2)
                            }
                          >
                            <span className="price-odd" id="runner3b2">
                              {runner3b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b2_matched"
                            >
                              {runner3b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr3_status span1details"
                            id="runner3b1span"
                            data-teamname="Hand 3"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 3", "1", runner3b1)
                            }
                          >
                            <span className="price-odd" id="runner3b1">
                              {runner3b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b1_matched"
                            >
                              {runner3b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr3_status span1details"
                            id="runner3l1span"
                            data-teamname="Hand 3"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 3", "1", runner3l1)
                            }
                          >
                            <span className="price-odd" id="runner3l1">
                              {runner3l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l1_matched"
                            >
                              {runner3l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr3_status span1details"
                            id="runner3l2span"
                            data-teamname="Hand 3"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 3", "2", runner3l2)
                            }
                          >
                            <span className="price-odd" id="runner3l2">
                              {runner3l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l2_matched"
                            >
                              {runner3l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr3_status span1details"
                            id="runner3l3span"
                            data-teamname="Hand 3"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 3", "3", runner3l3)
                            }
                          >
                            <span className="price-odd" id="runner3l3">
                              {runner3l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l3_matched"
                            >
                              {runner3l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr3_status"
                            style={{
                              display:
                                suspend3 != 0 ||
                                rnr3_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr3_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b4status">
                          <h3
                            className={`runner-name ${
                              rnr4_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hand 4
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus4">
                                    {book4 !== "" ? (
                                      Number(book4) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book4)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book4)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr4_status span1details"
                            id="runner4b3span"
                            data-teamname="Hand 4"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 4", "3", runner4b3)
                            }
                          >
                            <span className="price-odd" id="runner4b3">
                              {runner4b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b3_matched"
                            >
                              {runner4b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr4_status span1details"
                            id="runner4b2span"
                            data-teamname="Hand 4"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 4", "2", runner4b2)
                            }
                          >
                            <span className="price-odd" id="runner4b2">
                              {runner4b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b2_matched"
                            >
                              {runner4b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr4_status span1details"
                            id="runner4b1span"
                            data-teamname="Hand 4"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("b", "Hand 4", "1", runner4b1)
                            }
                          >
                            <span className="price-odd" id="runner4b1">
                              {runner4b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b1_matched"
                            >
                              {runner4b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr4_status span1details"
                            id="runner4l1span"
                            data-teamname="Hand 4"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 4", "1", runner4l1)
                            }
                          >
                            <span className="price-odd" id="runner4l1">
                              {runner4l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l1_matched"
                            >
                              {runner4l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr4_status span1details"
                            id="runner4l2span"
                            data-teamname="Hand 4"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 4", "2", runner4l2)
                            }
                          >
                            <span className="price-odd" id="runner4l2">
                              {runner4l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l2_matched"
                            >
                              {runner4l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr4_status span1details"
                            id="runner4l3span"
                            data-teamname="Hand 4"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("l", "Hand 4", "3", runner4l3)
                            }
                          >
                            <span className="price-odd" id="runner4l3">
                              {runner4l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l3_matched"
                            >
                              {runner4l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr4_status"
                            style={{
                              display:
                                suspend4 != 0 ||
                                rnr4_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr4_status}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="ResultsData"
                  className="tabcontent"
                  style={{ display: showResult ? "contents" : "none" }}
                >
                  {resultData &&
                    resultData.length > 0 &&
                    resultData.map((dataObj, index) => {
                      let win1 = dataObj.rnr1_status;
                      let win2 = dataObj.rnr2_status;
                      let win3 = dataObj.rnr3_status;
                      let win4 = dataObj.rnr4_status;

                      let bgCls1 = win1 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls2 = win2 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls3 = win3 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls4 = win4 == "WINNER" ? "bgwinner" : "bgLoser";

                      let tdCls1 = win1 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls2 = win2 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls3 = win3 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls4 = win4 == "WINNER" ? "TdResultsWin" : "";

                      let cardsArr = dataObj.cards_desc.split(",");
                      let rnr1Arr = dataObj.rnr1_desc.split(",");
                      let rnr2Arr = dataObj.rnr2_desc.split(",");
                      let rnr3Arr = dataObj.rnr3_desc.split(",");
                      let rnr4Arr = dataObj.rnr4_desc.split(",");
                      return (
                        <div class="left-content">
                          <div
                            class="card"
                            style={{
                              border: "1px solid rgb(204, 204, 204)",
                              borderRadius: "8px",
                              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                              marginBottom: "5px",
                              background:
                                "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                              color: "white",
                              marginLeft: "5px",
                              marginRight: "5px"
                            }}
                          >
                            <div
                              class="card-header no-border"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginBottom: "5px",
                                backgroundColor: "rgba(0, 0, 0, .03)",
                                marginTop: "12px",
                                marginLeft: "16px"
                              }}
                            >
                              {formatResultDate(dataObj.evt_od)} - <b>ID=</b>{" "}
                              {dataObj._id}
                            </div>
                            <div class="card-body">
                              <div
                                class="players-table"
                                style={{ textAlign: "center", width: "100%" }}
                              >
                                <table style={tableStyle}>
                                  <tbody>
                                    <tr style={rowFlexStyle}>
                                      <td
                                        style={communityTdStyle}
                                        className="TdResults"
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Community Cards
                                          </div>
                                          <div
                                            className="card-images"
                                            style={cardImagesStyle}
                                          >
                                            {cardsArr &&
                                              cardsArr.length > 0 &&
                                              cardsArr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>

                                    <tr
                                      style={rowFlexStyle}
                                      className="community-row"
                                    >
                                      <td
                                        style={tdResultsStyle}
                                        className={`TdResults ${tdCls1}`}
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Hand 1
                                          </div>
                                          <div
                                            className="card-images"
                                            style={cardImagesStyle}
                                          >
                                            {rnr1Arr &&
                                              rnr1Arr.length > 0 &&
                                              rnr1Arr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                          <div
                                            className={`player-status ${bgCls1}`}
                                            style={playerStatusStyle}
                                          >
                                            {dataObj.rnr1_status}
                                          </div>
                                        </div>
                                      </td>

                                      <td
                                        style={tdResultsStyle}
                                        className={`TdResults ${tdCls2}`}
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Hand 2
                                          </div>
                                          <div
                                            className="card-images"
                                            style={cardImagesStyle}
                                          >
                                            {rnr2Arr &&
                                              rnr2Arr.length > 0 &&
                                              rnr2Arr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                          <div
                                            className={`player-status ${bgCls2}`}
                                            style={playerStatusStyle}
                                          >
                                            {dataObj.rnr2_status}
                                          </div>
                                        </div>
                                      </td>

                                      <td
                                        style={tdResultsStyle}
                                        className={`TdResults ${tdCls3}`}
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Hand 3
                                          </div>
                                          <div
                                            className="card-images"
                                            style={cardImagesStyle}
                                          >
                                            {rnr3Arr &&
                                              rnr3Arr.length > 0 &&
                                              rnr3Arr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                          <div
                                            className={`player-status ${bgCls3}`}
                                            style={playerStatusStyle}
                                          >
                                            {dataObj.rnr3_status}
                                          </div>
                                        </div>
                                      </td>

                                      <td
                                        style={tdResultsStyle}
                                        className={`TdResults ${tdCls4}`}
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Hand 4
                                          </div>
                                          <div
                                            className="card-images"
                                            style={cardImagesStyle}
                                          >
                                            {rnr4Arr &&
                                              rnr4Arr.length > 0 &&
                                              rnr4Arr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                          <div
                                            className={`player-status ${bgCls4}`}
                                            style={playerStatusStyle}
                                          >
                                            {dataObj.rnr4_status}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div
                className="col-lg-4"
                style={{ paddingLeft: "1px", paddingRight: "1px" }}
              >
                <div className="right-content">
                  <div>
                    {showBetSlipPopup && (
                      <TPPopUpBetSlip
                        closeBetSlipParent={closeBetSlipMobile}
                        betObj={placeBetObject}
                        placeBetParent={placeBet}
                        betButtonShow={betButtonShow}
                        betErrorMessageObj={betErrorMessageObj}
                        betButtonShowLoaderShow={betButtonShowLoaderShow}
                        profileData={profileData}
                        loading={loading}
                        stakeList={stakeList}
                      />
                    )}
                    <BetfairCasinoBetslipWeb
                      showBetSlip={showBetSlip}
                      placeBetObject={placeBetObject}
                      closeBetSlipParent={closeBetSlip}
                      placeBetParent={placeBet}
                      stakeList={stakeList}
                      loading={loading}
                      betErrorMessageObj={betErrorMessageObj}
                    ></BetfairCasinoBetslipWeb>
                    <div className="bets">
                      <strong style={{ color: "white" }}>
                        Matched Bets ({totalBets})
                      </strong>
                      <div className="betting-table">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Runner</th>
                              <th>Price</th>
                              <th>Size</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody id="refreshhistory">
                            {betList.length > 0 ? (
                              betList.map((item, index) => (
                                <tr
                                  style={{
                                    background:
                                      item.type == "b" ? "#e9f6fc" : "#fce3e4",
                                    color: "#000",
                                    fontSize: "15px",
                                    textAlign: "center"
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "15px",
                                      display: "table-cell",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.rnr !== "" ? (
                                      item.rnr == "runner1b1" ||
                                      item.rnr == "runner1b2" ||
                                      item.rnr == "runner1b3" ||
                                      item.rnr == "runner1l1" ||
                                      item.rnr == "runner1l2" ||
                                      item.rnr == "runner1l3" ? (
                                        <span>Hand 1</span>
                                      ) : item.rnr == "runner2b1" ||
                                        item.rnr == "runner2b2" ||
                                        item.rnr == "runner2b3" ||
                                        item.rnr == "runner2l1" ||
                                        item.rnr == "runner2l2" ||
                                        item.rnr == "runner2l3" ? (
                                        <span>Hand 2</span>
                                      ) : item.rnr == "runner3b1" ||
                                        item.rnr == "runner3b2" ||
                                        item.rnr == "runner3b3" ||
                                        item.rnr == "runner3l1" ||
                                        item.rnr == "runner3l2" ||
                                        item.rnr == "runner3l3" ? (
                                        <span>Hand 3</span>
                                      ) : item.rnr == "runner4b1" ||
                                        item.rnr == "runner4b2" ||
                                        item.rnr == "runner4b3" ||
                                        item.rnr == "runner4l1" ||
                                        item.rnr == "runner4l2" ||
                                        item.rnr == "runner4l3" ? (
                                        <span>Hand 4</span>
                                      ) : (
                                        <span></span> // For any other value
                                      )
                                    ) : (
                                      <span></span>
                                    )}
                                    - {item.cat_mid}
                                  </td>
                                  <td
                                    style={{
                                      display: "table-cell",
                                      textAlign: "left",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.rate}
                                  </td>
                                  <td
                                    style={{
                                      display: "table-cell",
                                      textAlign: "left",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.amnt}
                                  </td>
                                  <td></td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </ClientLayout>
  );
};

export default BetfairTurboHold;


